import React, { useCallback, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

export const Modal = ({ message, isOpen, onClose, children }) => {
  const modalRef = useRef(null);

  const closeWithTransition = useCallback(() => {
    const el = modalRef.current;
    if (!el) {
      onClose();
      return;
    }

    const handleTransitionEnd = (e) => {
      if (e.target !== el) return;
      el.removeEventListener('transitionend', handleTransitionEnd);
      onClose();
    };

    el.addEventListener('transitionend', handleTransitionEnd);
    el.setAttribute('aria-hidden', 'true');
  }, [onClose]);


  useEffect(() => {
    const close = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', close);
    return () => window.removeEventListener('keydown', close);
  }, [onClose]);
  
  if (!isOpen) return null;
  
  return ReactDOM.createPortal(
    <>
    <div className="modal-overlay" onClick={closeWithTransition}>
    </div>
    <div className="modal-container" ref={modalRef} aria-hidden="false">
      <div className="modal-body">
        {message ? <p>{message}</p> : ""}
        {children}
      </div>
      <span className="modal-close" onClick={closeWithTransition}>Close</span>
    </div>
    </>
    ,document.body
  );
}
